/**
 * SakBisHandler — document-level Back-in-Stock click handler.
 *
 * Loaded unconditionally on product pages (theme.liquid) so BIS works
 * regardless of whether sibling-color-swapper.js is enabled.
 *
 * Listens at capture phase so it fires even when .klaviyo-bis-trigger is
 * inside a zone that gets replaced by the color swapper — the listener is
 * never orphaned by DOM surgery. Tracks the selected variant via
 * theme:variant:change so the correct variant is pre-selected in the modal.
 *
 * DO NOT attach click listeners for .klaviyo-bis-trigger inside
 * .product__block--buttons. That zone is replaced on every color swap —
 * any listener attached inside it is immediately orphaned.
 */
(function () {
  class SakBisHandler {
    constructor() {
      this._currentVariantId = null;
      document.addEventListener('theme:variant:change', this._onVariantChange.bind(this));
      document.addEventListener('click', this._onClick.bind(this), true);
    }

    _onVariantChange(e) {
      const variant = e?.detail?.variant;
      if (variant?.id) this._currentVariantId = String(variant.id);
    }

    _onClick(e) {
      if (typeof e.target?.closest !== 'function') return;
      const btn = e.target.closest('.klaviyo-bis-trigger');
      if (!btn) return;
      if (btn.hasAttribute('hidden') || btn.classList.contains('hidden')) return;
      if (!window._sakBisOptions?.account) return;

      e.preventDefault();
      e.stopPropagation();
      this._dispatch();
    }

    _dispatch() {
      let pd = null;
      try { pd = JSON.parse(document.querySelector('[data-product-json]')?.textContent); } catch (_) {}
      if (!pd) return;

      const oosVariants = (pd.variants || [])
        .filter(v => !v.available)
        .map(v => ({ id: String(v.id), title: v.title }));
      if (!oosVariants.length) return;

      const urlVariantId = new URLSearchParams(window.location.search).get('variant');
      const selectedVariantId = this._currentVariantId || urlVariantId || oosVariants[0].id;

      document.dispatchEvent(new CustomEvent('sak:bis:open', {
        bubbles: true,
        detail: { productTitle: pd.title || '', oosVariants, selectedVariantId },
      }));
    }
  }

  function init() {
    new SakBisHandler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
